<template>
  <div >
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="!fetched"
      ></v-progress-linear>
    </div>
    <span v-if="bids.length === 0 && fetched">
      <v-alert outlined color="primary" class="ma-1">
        {{ $t("common.no_data_available") }}
      </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t("common.status") }}
            </th>
            <th class="text-left">{{ $t("common.customer") }}</th>
            <th class="text-left">{{ $t("common.car") }}</th>
            <th class="text-left">
              {{ $t("common.date") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bid in bids" :key="bid.id">
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <strong v-bind="attrs" v-on="on">
                    <span
                      :style="{
                        background: bid && bid.stage && bid.stage.color,
                      }"
                      class="mpa-1 d-inline-block mx-1 status-square"
                    ></span>
                  </strong>
                </template>
                {{
                  bid.stage && bid.stage.is_system
                    ? $t("viewBids.stages." + bid.stage.system_name)
                    : bid.stage.name || ""
                }}
              </v-tooltip>
            </td>
            <td>
              <span
                class="py-0 ml-1 dashed"
                @click.stop="
                  bidWindow.bidId = bid.id;
                  bidWindow.customer = bid.customer;
                  bidWindow.isVisible = true;
                "
              >
                <span v-if="bid.customer">
                  {{ bid.customer.full_name }}
                </span>
                <span v-else>
                  {{ bid.customer_name }}
                </span>
              </span>
            </td>
            <td>
              <div v-if="bid.car" class="d-inline">
                <img
                    class="brandLogoMiddle"
                    v-if="!!brandURL(bid.car ? bid.car.brand : bid.brand)"
                    :src="brandURL(bid.car ? bid.car.brand : bid.brand)"
                />
                <span v-else>
                  {{ bid.car && bid.car.brand.toUpperCase() }}
                </span>
              </div>
              <template v-if="bid.car">
                <span   class="text-caption">
                  {{ bid.car.name }}
                </span>
                <beauty-car-number
                    v-if="bid.car && bid.car.car_number"
                    :number="bid.car.car_number"
                ></beauty-car-number>
              </template>
              <template v-else class="text-caption">
                <span   class="text-caption">
                {{ bid.brand }} {{ bid.model }}
                </span>
                <beauty-car-number
                    v-if="bid.car_number"
                    :number="bid.car_number"
                ></beauty-car-number>
              </template>
            </td>
            <td>
              <span class="text-caption"
                >{{ bid.created_at | moment("DD.MM.YYYY") }}
                {{ bid.created_at | moment("HH:mm") }}</span
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>


    <bid-window
      :show="bidWindow.isVisible"
      :bid-id="bidWindow.bidId"
      :customer="bidWindow.customer"
      @update="getData()"
      @hide="
        bidWindow.isVisible = false;
        bidWindow.customer = null;
        bidWindow.bidId = null;
      "
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import BidWindow from "@/components/bid/BidWindow.vue";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "@/components/common/BeautyCarNumber.vue";

export default {
  name: "MainWidgetBids",
  components: { BeautyCarNumber, BidWindow },
  mixins: [CommonMixin],
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    bidWindow: {
      isVisible: false,
      customer: null,
      bidId: null,
    },
  }),
  mounted() {
    this.getData();
  },
  computed: {
    ...mapFields("bids", [
      "bids",
      "search",
      "period",
      "fetched",
      "stagesForSearch",
      "tableOptions",
    ]),
  },
  methods: {
    getData() {
      this.stagesForSearch = "-1";
      this.search = "";
      this.period = {
        from: null,
        to: null,
      };
      this.tableOptions = {
        page: 1,
        last_page: 1,
        itemsPerPage: this.limit,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      };
      this.$store.dispatch("bids/getList");
    },
  },
  watch: {
    limit() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.brandLogoMiddle {
  width: 16px;
}
</style>
